import PropTypes from 'prop-types';
export const errorMessagesShape = {
  REQUIRED: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  INVALID_FORMAT: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  BELOW_MIN_DATE: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ABOVE_MAX_DATE: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  DATE_RANGE_ORDER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  BELOW_MIN_NUMBER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ABOVE_MAX_NUMBER: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  BELOW_MIN_ITEMS: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ABOVE_MAX_ITEMS: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};